import React from "react";

import styled from "styled-components";

import { HomeIcon } from "../icon/Icons";
import { DocsIcon } from "../icon/Icons";
import { AddFeatureIcon } from "../icon/Icons";
import { ShareIcon } from "../icon/Icons";
import { FolderOpenIcon } from "../icon/Icons";
import { getLogout, infoAction } from "../slices/LoginInfoSlice";
import { useDispatch, useSelector } from "react-redux";
import { BackIcon } from "../icon/Icons";
import { commonAction } from "../slices/GameSlice";
import LoginPage from "./LoginPage";

const TabItem = ({ icon, text, onClick }) => {
  return (
    <TabWrap onClick={() => onClick?.()}>
      <TabIconSpan>{icon}</TabIconSpan>
      <span>{text}</span>
    </TabWrap>
  );
};

const LoginWrap = () => {
  const dispatch = useDispatch();
  const { status, assign } = useSelector((state) => state.LoginInfoSlice);
  const { boardDisplay } = useSelector((state) => state.GameSlice);
  const tabArr = [
    { icon: <HomeIcon />, text: "홈" },
    { icon: <DocsIcon />, text: "새로 만들기" },
    { icon: <FolderOpenIcon />, text: "열기" },
    { icon: <ShareIcon />, text: "공유" },
  ];

  const secondTaps = [
    {
      icon: <AddFeatureIcon />,
      text: "추가 기능 가져오기",
      onClick: () =>
        dispatch(
          commonAction({ target: "boardDisplay", value: !boardDisplay })
        ),
    },
    { icon: null, text: "정보" },
    { icon: null, text: "저장" },
    { icon: null, text: "다른 이름으로 저장" },
    { icon: null, text: "인쇄" },
    { icon: null, text: "내보내기" },
    { icon: null, text: "게시" },
    { icon: null, text: "닫기" },
  ];

  return (
    <MiddleWrap>
      <TabColumns>
        <BackArea>
          {assign && (
            <span
              onClick={() =>
                dispatch(infoAction({ target: "assign", value: false }))
              }
              style={{ cursor: "pointer" }}
            >
              <BackIcon />
            </span>
          )}
        </BackArea>
        {tabArr.map((item, index) => (
          <TabItem
            key={`${index}tabKey`}
            onClick={item.onClick}
            text={item.text}
            icon={item.icon}
          />
        ))}
        <DivideLine />
        {secondTaps.map((item, index) => (
          <TabItem
            key={`${index}secondTabKey`}
            onClick={item.onClick}
            text={item.text}
            icon={item.icon}
          />
        ))}
        <div
          style={{
            marginTop: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <DivideLine />
          <LogoutItem $status={status} onClick={() => dispatch(getLogout())}>
            로그아웃
          </LogoutItem>
        </div>
      </TabColumns>
      <ContentWrap>
        <LoginPage />
      </ContentWrap>
    </MiddleWrap>
  );
};
export default LoginWrap;

const BackArea = styled.div`
  width: 100%;
  height: 20px;
`;

const ContentWrap = styled.div`
  background-color: #f5f5f5;
  width: 1780px;
  height: 836px;
  box-shadow: -1px -1px 4px 0 rgba(0, 0, 0, 0.25);
  position: relative;
`;

const TabWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  color: #242424;
  font-size: 13px;
  cursor: pointer;
`;

const LogoutItem = styled.div`
  width: 100%;
  padding: 8px 0 8px 40px;
  font-size: 12px;
  ${({ $status }) =>
    $status
      ? "border-left: 2px solid #107C41;color:#107c41;cursor:pointer;translate:-2px 0;&:hover{opacity:0.8;}"
      : "color:#242424;"}
`;

const TabIconSpan = styled.span`
  width: 20px;
  height: 20px;
`;

const TabColumns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;
  padding-top: 56px;
`;

const MiddleWrap = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
`;

const DivideLine = styled.div`
  width: 100px;
  height: 1px;
  margin: 0 auto;
  background-color: #d1d1d1;
`;
